import React, { useState } from "react";
import AnimationRevealPage from "../../components/helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components";
import illustration from "../../images/img/Security-rafiki.svg";
import logo from "../../images/logo/logo-kz.svg";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../FireBaseConfig";
import { Link } from "react-router-dom";
import { Toaster, toast } from "react-hot-toast";
import Header from "../../components/headers/light";
import { useTranslation } from "react-i18next";

const Container = tw.div`min-h-screen bg-gray-100 flex items-center justify-center`;
const Content = tw.div`flex flex-col lg:flex-row bg-white rounded-2xl shadow-2xl max-w-4xl w-full overflow-hidden`;
const LeftContainer = tw.div`w-full lg:w-1/2 p-8 lg:p-16 flex flex-col justify-center items-center`;
const RightContainer = tw.div`hidden lg:flex w-1/2 bg-gray-100 items-center justify-center`;
const Logo = tw.img`h-12 mb-6`;
const Heading = tw.h1`text-3xl font-bold text-gray-800 mb-4 text-center`;
const SubText = tw.p`text-sm text-gray-600 mb-6 text-center`;
const Form = tw.form`w-full max-w-md`;

const Input = styled.input`
    ${tw`w-full px-4 py-3 bg-gray-100 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-sm`}
    box-sizing: border-box;
    width: 100%;
    margin-bottom: 1rem;
    padding: 0.75rem 1rem;
`;

const SubmitButton = styled.button`
    ${tw`w-full px-4 py-3 bg-green-1002 text-white font-bold rounded-lg shadow-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400 transition duration-300`}
    box-sizing: border-box;
    width: 100%;
    padding: 0.75rem 1rem;
    margin-top: 1rem;
`;

const IllustrationContainer = tw.div`w-full h-full bg-contain bg-center`;
const IllustrationImage = tw.img`max-w-full h-auto`;

const ForgotPassword = () => {
    const { t } = useTranslation();
    const [email, setEmail] = useState("");

    const handleSendPasswordResetEmail = async (e) => {
        e.preventDefault();
        const trimmedEmail = email.trim();

        if (!trimmedEmail) {
            toast.error(t("auth.reset.errors.enterEmail"));
            return;
        }

        try {
            await sendPasswordResetEmail(auth, trimmedEmail);
            toast.success(t("auth.reset.toasts.sent"));
        } catch (error) {
            if (error.code === "auth/user-not-found") {
                toast.error(t("auth.reset.errors.notFound"));
            } else {
                toast.error(t("auth.reset.errors.generic", { message: error.message }));
            }
        }
    };

    return (
        <>
            <Header />
            <AnimationRevealPage>
                <Container>
                    <Content>
                        <LeftContainer>
                            <Link to={"/"}>
                                <Logo src={logo} alt="Eparcel Logo" />
                            </Link>
                            <Heading>{t("auth.reset.title")}</Heading>
                            <SubText>{t("auth.reset.subtitle")}</SubText>
                            <Form onSubmit={handleSendPasswordResetEmail}>
                                <Input
                                    type="email"
                                    placeholder={t("auth.reset.placeholder")}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <SubmitButton type="submit">{t("auth.reset.submit")}</SubmitButton>
                            </Form>
                        </LeftContainer>
                        <RightContainer>
                            <IllustrationContainer>
                                <IllustrationImage src={illustration} alt="Forgot Password Illustration" />
                            </IllustrationContainer>
                        </RightContainer>
                    </Content>
                    <Toaster position="top-right" reverseOrder={false} />
                </Container>
            </AnimationRevealPage>
        </>
    );
};

export default ForgotPassword;
